export default "__VITE_ASSET__BPuzxhnt__"